import { withInstall } from '@element-plus/utils'
import Statistic from './src/statistic.vue'

export const ElStatistic = withInstall(Statistic)

export default ElStatistic
export * from './src/statistic'
